
export function inject_dedent(offside_lines, trailing_types) ::
  if 'function' !== typeof trailing_types ::
    const s_trailing_types = new Set @
      trailing_types || ['comment_eol']
    trailing_types = k => s_trailing_types.has(k)

  for const ln of offside_lines ::
    if ln.is_blank :: continue

    const {len_dedent, len_indent, len_inner} = ln

    const offside_dedent = @{}
      type: 'offside_dedent'
      len_dedent, len_indent

    if len_inner ::
      offside_dedent.len_inner = len_inner

    const last = ln.content.pop()
    if last.multiline || trailing_types(last.type) ::
      ln.content.push @ offside_dedent, last
    else ::
      ln.content.push @ last, offside_dedent

